import { instance } from '@/libs/api/instance'

/**
 * Update user's password
 *
 * @param currentPassword
 * @param password
 * @param passwordRepeat
 * @param signToken
 * @param validate
 * @return {Promise<AxiosResponse<any>>}
 */
export const changePassword = async (
  { currentPassword, password, passwordRepeat, signToken },
  { validate },
) => {
  return instance.post(
    '/v1/auth/password/change',
    {
      currentPassword,
      password,
      passwordRepeat,
      signToken,
    },
    {
      params: {
        validate: Number(validate),
      },
    },
  )
}
